import type { ValidationRuleset } from 'lib/validation'
import { notEmptyValidator, emailValidator } from 'lib/validation'
// Validation Rules
export const formValidationRulesNewsletter: ValidationRuleset = {
  email: [
    {
      ...notEmptyValidator,
      ...emailValidator,
      message: () => 'Please enter a valid email address.',
    },
  ],
}